export const accordion = () => {

  document
    .querySelectorAll('.wp-block-group.is-accordion')
    .forEach((block, i) => {
      // const swiperEl = '.is-style-slider';
      // $(block).removeClass(function (index, css) {
      //   return (css.match(/\bwp-\S+/g) || []).join(' '); // removes anything that starts with "wp-container"
      // });
      // $(swiperEl).attr('class', 'wp-block-gallery is-style-slider swiper');
      let wrap = $(block).children('.wp-block-group__inner-container');
      let title = wrap.find('.wp-block-heading').addClass('accordion--title').wrapInner('<span class="accordion--title--text"></span>').append('<span class="accordion--close"><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.46 55.4"><polygon class="close" points="66.43 2.12 64.31 0 38.73 25.58 13.16 0 11.03 2.12 36.61 27.7 11.03 53.28 13.16 55.4 38.73 29.82 64.31 55.4 66.43 53.28 40.85 27.7 66.43 2.12"/><polygon class="arrow" points="55.47 9.95 71.72 26.2 0 26.2 0 29.2 71.72 29.2 55.47 45.45 57.59 47.57 77.46 27.7 57.59 7.83 55.47 9.95"/></svg></span>');

      $(block)
        .addClass('accordion inview');

      title
        .next()
        .wrap('<div class="accordion--content"></div>');

      
    });

    $('.accordion--title').on("click", function (e) {

      e.preventDefault();

      var parent = $(this).closest('.accordion');
      
      if ( !parent.hasClass('is-expanded') ) {

        $('.accordion').removeClass('is-expanded');
        parent.addClass('is-expanded');

        var parentOffset = parent.offset();

        console.log(parentOffset);

        $('html, body').animate({
          scrollTop: parentOffset.top
        }, 250);

      } else {
        parent.removeClass('is-expanded');
      }

    });

 }